import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle } from 'lucide-react';
import api from '../utils/api';
import { Button } from '../components/ui/button';

const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [status, setStatus] = useState('loading');
  const [amount, setAmount] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus('error'); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === 'paid') {
          setStatus('paid');
          return;
        }
        if (tries++ < 6) setTimeout(poll, 1200);
        else setStatus('pending');
      } catch { setStatus('error'); }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen pt-24 flex items-center justify-center bg-[#04140e]">
      <div className="bg-white border border-[#c5a059]/40 rounded-sm max-w-md w-full p-12 text-center" data-testid="payment-success">
        {status === 'paid' && (
          <>
            <CheckCircle className="w-16 h-16 text-green-600 mx-auto mb-4" />
            <h1 className="font-serif text-3xl text-[#0d3b25] font-bold mb-2">Betaling ontvangen</h1>
            <p className="text-muted-foreground mb-8">Uw aanbetaling is bevestigd. Tot snel in de salon!</p>
          </>
        )}
        {status === 'pending' && (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#c5a059] mx-auto mb-4"></div>
            <h1 className="font-serif text-2xl text-[#0d3b25] mb-2">Verwerken…</h1>
            <p className="text-muted-foreground text-sm">Even geduld terwijl we uw betaling verifiëren.</p>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h1 className="font-serif text-3xl text-[#0d3b25] font-bold mb-2">Er ging iets mis</h1>
            <p className="text-muted-foreground text-sm mb-8">Neem contact op met de salon om de betaling af te ronden.</p>
          </>
        )}
        <Link to="/account"><Button className="bg-[#04140e] text-[#c5a059] rounded-full">Mijn afspraken</Button></Link>
      </div>
    </div>
  );
};

export default PaymentSuccess;
